export enum ExpenseStatus {
  AwaitingReview = 0,
  Verified = 1,
  ActionRequired = 2,
  Ineligible = 3,
  AwaitingAdminReview = 4,
}
